import { FullScreen } from 'leaflet.fullscreen';
import { useEffect } from 'react';
import { useMap } from 'react-leaflet';

import 'leaflet.fullscreen/dist/Control.FullScreen.css';

const FullscreenControl = () => {
  const map = useMap();

  useEffect(() => {
    const control = new FullScreen({
      forcePseudoFullscreen: false,
    });
    map.addControl(control);

    return () => {
      map.removeControl(control);
    };
  }, [map]);

  return null;
};

export default FullscreenControl;
